import { toItem } from '../mappers/item';
import { flatten } from 'ramda';
import { InstagramMediaTypes } from '../constants';
export function parseItems(res) {
  const cursors = res.data.cursors || null;
  res.data = flatten((res.data.data || []).map(item => item.media_type === InstagramMediaTypes.CAROUSEL_ALBUM ? (item.children.data || []).map(carouselItem => toItem({
    ...carouselItem,
    caption: item.caption
  })) : toItem(item)));
  res.paging = {
    cursor: cursors && cursors.after
  };
  return res;
}